'use strict';

angular.module('commerce')
    .component('subscriptionDetails', {
        require: {
            study: '^^studyMain',
        },
        templateUrl: 'js/modules/commerce/components/subscription-details/template.html',
        controller: 'SubscriptionDetailsController',
    });
